<div class="add-to-cart">
    <div class="add-to-cart__title text-center">
        Unlock {{ cartItem?.displayName }}
    </div>
    <div class="add-to-cart__subtitle text-center">
        <ng-content></ng-content>
    </div>
    <div class="add-to-cart__card">
        <div class="add-to-cart__report-body">
            <div class="add-to-cart__report-details">
                <div class="add-to-cart__report-name">
                    {{ cartItem?.displayName }}
                    <p class="add-to-cart__report-price">
                        ${{ cartItem?.price | number: '1.2-2' }}
                    </p>
                </div>
                <div class="add-to-cart__report-includes">
                    <p>
                        {{ cartItem?.displayName }} includes:
                    </p>
                    <div class="add-to-cart__report-item" *ngFor="let item of reportIncludes">
                        <span>
                            <i class="fa fa-check-circle"></i>
                            {{ item }}
                        </span>
                    </div>
                    <button class="add-to-cart__download-sample-report btn-blue" (click)="downloadSampleReport()">
                        <i class="fa fa-download" aria-hidden="true"></i>
                        Download Sample Report
                    </button>
                </div>
            </div>
        </div>
        <div class="add-to-cart__report-footer d-flex justify-content-between align-items-center">
            <span *ngIf="!noReportExists" class="add-to-cart__total-price">
                <span class="add-to-cart__total-label">
                    Total:
                </span>
                ${{ cartItem?.price | number: '1.2-2' }}
            </span>
            <span *ngIf="noReportExists" class="add-to-cart__message">{{ cartItem?.displayName }} Report is unavailable for the selected property</span>
            <button *ngIf="cartItem?.state !== 'View'" class="add-to-cart__button btn-blue" [disabled]="noReportExists || cartItem?.state === 'In Cart'" (click)="addToCart()">
                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                Add to Cart
            </button>
            <button *ngIf="cartItem?.state === 'View'" [disabled]="noReportExists" class="add-to-cart__button btn-blue" (click)="viewReport()">
                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                View Report
            </button>
        </div>
    </div>
</div>
